/**
 * Endpoint de cliente — backend real (proxy a ACSIS).
 * GET /api/despacho/cliente/:id
 */

import { ClienteSchema, type Cliente } from '@/api/contracts/cliente';
import { apiFetch } from '@/api/http';

export async function getCliente(id: string): Promise<Cliente> {
  const data = await apiFetch<unknown>(
    `/despacho/cliente/${encodeURIComponent(id)}`,
    { auth: true },
  );
  return ClienteSchema.parse(data);
}
